module.exports = __webpack_public_path__ + "img/binding2.1e666fea.jpg";